/** @format */

export const ignoredEventTypes = new Set(['@@redux/INIT', '@@INIT'])
export const isIgnoredEventType = type => ignoredEventTypes.has(type)
